/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_EmptyInputs */

const en_lessons_empty = /** @type {(inputs: Lessons_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No lessons yet.`)
};

const he_lessons_empty = /** @type {(inputs: Lessons_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין שיעורים עדיין.`)
};

/**
* | output |
* | --- |
* | "No lessons yet." |
*
* @param {Lessons_EmptyInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_empty = /** @type {((inputs?: Lessons_EmptyInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_EmptyInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_empty(inputs)
	return he_lessons_empty(inputs)
});